import {createSlice, type PayloadAction} from '@reduxjs/toolkit';

export type SsoLinkStatus = 'loading' | 'success' | 'failed';

export interface SsoLink {
    link?: string;
    status?: SsoLinkStatus;
    expirationDate?: number;
}

interface AddSsoLinkPayload {
    template: string;
    link?: string;
    status?: SsoLinkStatus;
    expirationDate?: number;
}

interface ExternalLinksState {
    ssoLinks: Record<string, SsoLink>;
}

const initialState: ExternalLinksState = {
    ssoLinks: {},
};

const externalLinksSlice = createSlice({
    name: 'externalLinks',
    initialState,
    reducers: {
        addSsoLink(state, action: PayloadAction<AddSsoLinkPayload>) {
            const {template, link, status, expirationDate} = action.payload;
            state.ssoLinks[template] = {link, status, expirationDate};
        },
        clearSsoLinks(state) {
            state.ssoLinks = {};
        },
    },
});

export const {addSsoLink, clearSsoLinks} = externalLinksSlice.actions;

export default externalLinksSlice.reducer;
